import { useState } from 'react';

import { GuideContent } from './components/guide-content';
import { GuideSidebar } from './components/guide-sidebar';
import { accommodationGuides } from './data/accommodation-guides';

export function GuidesPage() {
  const [selectedId, setSelectedId] = useState(accommodationGuides[0]!.id);
  const selectedGuide = accommodationGuides.find((g) => g.id === selectedId) ?? accommodationGuides[0]!;

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <h1 className="text-2xl font-bold">Accommodation Guides</h1>
      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="w-full shrink-0 lg:w-64">
          <GuideSidebar
            guides={accommodationGuides}
            selectedId={selectedId}
            onSelect={setSelectedId}
          />
        </div>
        <div className="flex-1">
          <GuideContent guide={selectedGuide} />
        </div>
      </div>
    </div>
  );
}
